import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../api/client';

/** A note for the next scheduled tips email; brand_key null = every brand. */
export interface EmailContextNote {
  id: number;
  brand_key: string | null;
  note: string;
  created_by: string | null;
  created_at: string;
}

const BASE = '/brevo/email-context-notes';
const KEY = ['email-context-notes'];

export function useEmailContextNotes() {
  return useQuery({ queryKey: KEY, queryFn: async () => (await apiClient<{ notes: EmailContextNote[] }>(BASE)).notes });
}

export function useAddEmailContextNote() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: { note: string; bothBrands: boolean }) => apiClient(BASE, { method: 'POST', body: JSON.stringify(body) }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: KEY }),
  });
}

export function useDeleteEmailContextNote() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => apiClient(`${BASE}/${id}`, { method: 'DELETE' }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: KEY }),
  });
}
